
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 20s1.838-6 12-6v6l12-8-12-8v6c-8 0-12 4.99-12 10zm14 4H4V12h3.934c.315-.372.654-.729 1.015-1.068 1.374-1.287 3.018-2.27 4.879-2.932H.001v20h26v-8.395l-4 2.667V24z"}})])
          )
        }
      }
    